
export default [
    {
        name: "ItemCreate",
        path: "item",
        component: () => import('./../../views/warehouse/ItemCreateView.vue'),
        
    },
    {
        name: "ItemDisplay",
        path: "item/:id",
        component: () => import('./../../views/warehouse/ItemDisplayView.vue')
    },
    {
        name: "ItemAccount",
        path: "item/:id/account/:id",
        component: () => import('./../../views/warehouse/ItemAccountCreateView')
    },
    {
        name: "ItemEdit",
        path: "item/:id/edit",
        component: () => import('./../../views/warehouse/ItemEditView.vue')
    },
    {
        name: "ItemList",
        path: "items",
        component: () => import('./../../views/warehouse/ItemListView.vue')
    },
    {
        name: "ItemMeasureUnitCreate",
        path: "item/:id/measure-unit",
        component: () => import('./../../views/warehouse/ItemMeasureUnitCreateView.vue')
    },
    {
        name: "ItemMeasureUnitEdit",
        path: "item/:id/measure-unit/:unitId/edit",
        component: () => import('./../../views/warehouse/ItemMeasureUnitEditView.vue')
    },
    {
        name: "ItemAccountCreate",
        path: "item/:id/account",
        component: () => import('./../../views/warehouse/ItemAccountCreateView.vue')
    },
    {
        name: "ItemAccountEdit",
        path: "item/:id/account/:accountId/edit",
        component: () => import('./../../views/warehouse/ItemAccountEditView.vue')

    },
]